import { Model } from '../parents/model';

export class UserModel extends Model {
  static ATTR_ID = 'id';
  static ATTR_EMAIL = 'email';
  static ATTR_USERNAME = 'username';
  static ATTR_ADDRESS = 'address';
  static ATTR_PHONE = 'phone';
  static ATTR_BIRTH_YEAR = 'birth_year';
  static ATTR_DESCRIPTION = 'description';
  static ATTR_IS_ACTIVE = 'is_active';
  static ATTR_CUSTOM_BUSINESS_CONDITIONS = 'custom_business_conditions';
  static ATTR_IMAGE_ID = 'image_id';
  static ATTR_HEADER_IMAGE_ID = 'header_image_id';
  static ATTR_ROLE_TYPE = 'role_type';
  static ATTR_HAS_SYSTEM_NOTIFICATIONS = 'has_system_notifications';
  static ATTR_HAS_SHOW_ACTIVITY = 'has_show_activity';
  static ATTR_HAS_NEWSLETTER = 'has_newsletter';
  static ATTR_HAS_DELETE_PERSONAL_DATA_REQUEST = 'has_delete_personal_data_request';
  static ATTR_HAS_DELETE_ACCOUNT_REQUEST = 'has_delete_account_request';
  static ATTR_CREATED_AT = 'created_at';

  /**
   * Embeds
   */
  static EMBED_ADVERTISEMENT_IDS = 'advertisement_ids';

  get id() {
    return this.attributes[UserModel.ATTR_ID];
  }

  get email() {
    return this.attributes[UserModel.ATTR_EMAIL];
  }

  get username() {
    return this.attributes[UserModel.ATTR_USERNAME];
  }

  get address() {
    return this.attributes[UserModel.ATTR_ADDRESS];
  }

  get phone() {
    return this.attributes[UserModel.ATTR_PHONE];
  }

  get birthYear() {
    return this.attributes[UserModel.ATTR_BIRTH_YEAR];
  }

  get description() {
    return this.attributes[UserModel.ATTR_DESCRIPTION];
  }

  get isActive() {
    return this.attributes[UserModel.ATTR_IS_ACTIVE];
  }

  get customBusinnesConditions() {
    return this.attributes[UserModel.ATTR_CUSTOM_BUSINESS_CONDITIONS];
  }

  get imageId() {
    return this.attributes[UserModel.ATTR_IMAGE_ID];
  }

  get headerImageId() {
    return this.attributes[UserModel.ATTR_HEADER_IMAGE_ID];
  }

  get roleType() {
    return this.attributes[UserModel.ATTR_ROLE_TYPE];
  }

  get hasSystemNotifications() {
    return this.attributes[UserModel.ATTR_HAS_SYSTEM_NOTIFICATIONS];
  }

  get hasShowActivity() {
    return this.attributes[UserModel.ATTR_HAS_SHOW_ACTIVITY];
  }

  get hasNewsletter() {
    return this.attributes[UserModel.ATTR_HAS_NEWSLETTER];
  }

  get hasDeletePersonalDataRequest() {
    return this.attributes[UserModel.ATTR_HAS_DELETE_PERSONAL_DATA_REQUEST];
  }

  get hasDeleteAccountRequest() {
    return this.attributes[UserModel.ATTR_HAS_DELETE_ACCOUNT_REQUEST];
  }

  get createdAt() {
    return this.attributes[UserModel.ATTR_CREATED_AT];
  }

  get createdAtFormatted() {
    return new Date(this.createdAt).toLocaleString('cs-CZ');
  }

  get advertisementIds() {
    return this.embeds[UserModel.EMBED_ADVERTISEMENT_IDS];
  }
}
